import React from 'react'
import { getPageMargins } from '../../../../configurations/GlobalConfig.js'
import { GetETypeName } from '../../../../configurations/enums/EType.js'
import { CHECK_URL } from '../../../../configurations/initUrls.js'
import { getLoginInfo } from '../../../../configurations/auth/getLoginInfo.js'
import QRCode from 'react-qr-code'
import moment from 'moment'

export const ConfirmOpdPrint = React.forwardRef((props, ref) => {
    const data = props.printData
    const userData = getLoginInfo()
    return (
        <div ref={ref}>
            <style type="text/css">
                {getPageMargins()}
            </style>
            {
                userData && data &&
                <div>
                    <div className="w-full flex justify-between items-center">
                        <div>
                            {userData &&
                                <h3 className="text-xl font-semibold text-gray-800">
                                    Dr. {userData && userData.fullName}
                                </h3>
                            }
                            <div>
                                <h3 class="text-[11px]">
                                    {userData.specialisation?.name} ({userData.specialisation?.shortName})
                                </h3>
                                <h3 class="text-[11px]">
                                    {userData.degree}
                                </h3>
                            </div>
                        </div>
                        <div className="flex flex-col items-center">
                            <QRCode size={50} value={CHECK_URL + data.id} />
                            <p className="text-xs text-gray-600 mt-1">Scan to check</p>
                        </div>
                    </div>
                    <div className='text-[11px]'>
                        <div class="col-sm-10 col-sm-offset-1">
                            <div class="widget-box transparent">

                                <div class="widget-body">
                                    {
                                        data &&
                                        <div className="mt-2">
                                            <table className="table-auto w-full border border-gray-300">
                                                <tbody>
                                                    <tr className="border-b">
                                                        <td className="px-2 py-1 border border-gray-300">Ref No: <span className='font-semibold'>{data.id}/{data.registeredIdForRef}</span></td>
                                                        <td className="px-2 py-1 border border-gray-300">Confirm Number: <span className='text-sm font-bold'>{data.confirmedAllotedNumber}</span>{data.confirmedAllotedNumber == data.opdNumberAlloted ? "" : "/" + data.opdNumberAlloted}</td>
                                                    </tr>
                                                    <tr className="border-b">
                                                        <td className="px-2 py-1 border border-gray-300">Patient Name</td>
                                                        <td className="px-2 py-1 border border-gray-300 font-bold">{data.patientName.toUpperCase()}</td>
                                                    </tr>
                                                    <tr className="border-b bg-gray-50">
                                                        <td colSpan={5} className="px-2 py-1 border border-gray-300 text-center">
                                                            <span className="mr-4">BP: <span className='font-bold'>{data.bloodPressure}</span></span>
                                                            <span className="mr-4">Weight: <span className='font-bold'>{data.weight}Kg</span></span>
                                                            <span className="mr-4">Age: <span className='font-bold'>{data.age}Y</span></span>
                                                            <span className="mr-4">BG: <span className='font-bold'>{data.bloodGroup}</span></span>
                                                        </td>

                                                    </tr>
                                                    <tr className="border-b bg-gray-50">
                                                        <td className="px-2 py-1 border border-gray-300">Type</td>
                                                        <td className="px-2 py-1 border border-gray-300 font-bold">
                                                            {GetETypeName(data.type)}
                                                        </td>
                                                    </tr>
                                                    <tr className="border-b">
                                                        <td className="px-2 py-1 border border-gray-300">Mobile</td>
                                                        <td className="px-2 py-1 border border-gray-300">{data.mobile}</td>
                                                    </tr>
                                                    <tr className="border-b">
                                                        <td className="px-2 py-1 border border-gray-300">Address</td>
                                                        <td className="px-2 py-1 border border-gray-300">{data.patientAddress}</td>
                                                    </tr>
                                                    <tr className="border-b bg-gray-100">
                                                        <td className="px-2 py-1 border border-gray-300">Date</td>
                                                        <td className="px-2 py-1 border border-gray-300">{moment(data.onDate).format("DD-MM-YYYY")}</td>
                                                    </tr>
                                                    <tr className="border-b bg-gray-100">
                                                        <td className="px-2 py-1 border border-gray-300">Timing</td>
                                                        <td className="px-2 py-1 border border-gray-300">{moment(data.opdCenter.opdStartTime).format("LT")} to {moment(data.opdCenter.opdEndTime).format("LT")}</td>
                                                    </tr>
                                                    <tr className="border-b bg-gray-100">
                                                        <td className="px-2 py-1 border border-gray-300">Center</td>
                                                        <td className="px-2 py-1 border border-gray-300 font-semibold">{data.opdCenter.centerName}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    }
                                </div>
                                <br />
                                <>
                                    <div className='w-full flex items-center justify-between'>
                                        <div>
                                            Signature ________________________
                                        </div>
                                        <div >
                                            <span className='text-[8px]'>Powered By</span>
                                            <img className="h-3 w-auto" src="/assets/images/logo.png" />
                                        </div>
                                    </div>
                                </>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div >
    )
})
